import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import './lib/splitText.js';

(function(){

  const scrollController = new ScrollMagic.Controller({
    globalSceneOptions: {
      reverse: false,
      triggerHook:1,
    }
  });

  // if (window.matchMedia("(min-width: 540px)").matches) {

    const barre = $('.barres .firsthover');
    const barresdiv = $('.barres > div');
    const barresImgs = $('.barres img');

    const s = new ScrollMagic.Scene({
      triggerElement:barresdiv[0],
    })
    .offset(100)
    .on("start",(e)=>{
      if(window.matchMedia("(min-width: 540px)").matches){
        TweenMax.staggerFromTo(barresdiv,0.7,{rotation:45,x:0,y:0,xPercent:-100,force3D:true,autoAlpha:0},{rotation:0,x:0,y:0,xPercent:0,force3D:true,autoAlpha:1},0.02,test);
      }else{
        TweenMax.staggerFromTo(barresdiv,0.7,{y:'+=100',force3D:true,autoAlpha:0},{y:0,force3D:true,autoAlpha:1},0.02);
      }
    })
    .addTo(scrollController);

    function test(){
      barre.addClass('isHover');
    }
    barresImgs.mouseenter(function(){
      barresImgs.removeClass('isHover');
      $(this).addClass('isHover');
    })

  // }


  const $base = $('.s-title2,.wysiwyg p,.barre-ingredients .s-title4,.barre-ingredients p,.eshop,.findUs,.s-title');
  $base.each(function(){
    const $this = $(this)[0];
    const s = new ScrollMagic.Scene({
      triggerElement:$this,
    })
    .offset(100)
    .on("start",(e)=>{
      TweenMax.fromTo($this,0.7,{y:'+=40',force3D:true,autoAlpha:0},{y:0,force3D:true,autoAlpha:1});
    })
    .addTo(scrollController);
  });


  const $title = $('.barre .s-title1');

  $title.each(function(){
    const $this = $(this)[0];
    const splitTitle = new SplitText($this,{type:"lines"}),
    charsTitle = splitTitle.lines
    ;
    const s = new ScrollMagic.Scene({
      triggerElement:$this,
    })
    .offset(100)
    .on("start",(e)=>{
      TweenMax.set($this,{alpha:1});
      TweenMax.staggerFromTo(charsTitle, 0.8, {opacity:0, y:40, transformOrigin:"0% 50%"},{opacity:1, y:0, transformOrigin:"50% 50%", force3D:true, ease:Power4.easeInOut}, 0.08,0)

    })
    .addTo(scrollController);
  });

  const $barreImg = $('.barre .barre-img');
  $barreImg.each(function(){
    const $this = $(this)[0];
    const s = new ScrollMagic.Scene({
      triggerElement:$this,
    })
    .offset(200)
    .on("start",(e)=>{
      TweenMax.set($this,{autoAlpha:1})
      TweenMax.fromTo($this, 0.8, {scale:0.5},{scale:1,force3D:true, ease:Elastic.easeOut.config(1, 0.4), z: 0 })
    })
    .addTo(scrollController);
  });

})();
